module.exports = __webpack_public_path__ + "static/media/fee collection.e69c499d.svg";